Greenmile.Task = Greenmile.Task || {};

Greenmile.Task.AssignResolution = function (taskRouter, sendChangeStatusCallBack) {

    this.showModal = () => this.modalForm.showModalForm();

    this.addFormToModalContent = () => {
        const modalContent = document.querySelector("#Task .popupFormContainer");

        if (modalContent) {
            try {
                const taskId = App.Forms.Task.form.fields.id.getValue();
                const contentToModal = this.constructForm(taskId);
                let lookupContainer;

                modalContent.appendChild(contentToModal.html);
                lookupContainer = modalContent.querySelector('.form-horizontal');
                lookupContainer.appendChild(contentToModal.lookup.rootEl);
                lookupContainer.appendChild(contentToModal.textarea.rootEl);

                this.addEventListenners();
            } catch (e) {
                new Monet.Exception.ReturnError(this, "No add form to modal.")
                    .console();
            }
        } else {
            new Monet.Exception.ReturnError(this, "No modal to add form.")
                .console();
        }
    };

    this.constructForm = (taskId) => {
        this.taskResolutionField = this.buildLookup();
        this.commentResolutionField = this.buildTextarea();
        return {
            html: this.buildTemplate(taskId),
            lookup: this.taskResolutionField,
            textarea: this.commentResolutionField
        };
    };

    this.buildLookup = () => {
        const field = new Monet.UI.Fields.PowerLookup();
        field.setId('taskResolution');
        field.setNameSpace('taskResolution');
        field.setLookUpEntity('TaskResolution');
        field.setDisplayKey('description');
        field.setTextLabel(Monet.I18n.getResourcesByKey('TaskManager.standardTaskResolution'));
        field.setInputName('description');
        field.render();

        return field;
    };

    this.buildTextarea = () => {
        const field = new Monet.UI.Fields.TextArea();
        field.setTextLabel(Monet.I18n.getResourcesByKey('TaskManager.taskResolution.comment'));
        field.render();

        return field;
    };

    this.buildTemplate = function (taskId) {
        const layout = {
            "items": [
                {
                    "tag": "form",
                    "items": [
                        {
                            "html": Monet.I18n.getResourcesByKey("task.transition.reopen.closed"),
                            "attributes": {
                                "class": "form_assign_taskResolution___header"
                            }
                        },
                        {
                            "items": [
                                {
                                    "attributes": {
                                        "class": "monetInlineAlerContainer"
                                    }
                                },
                                {
                                    "tag": "input",
                                    "attributes": {
                                        "type": "hidden",
                                        "id": "taskResolution_id",
                                        "name": "taskResolution.id",
                                        "value": taskId,
                                        "class": "modelAttribute"
                                    }
                                }
                            ],
                            "attributes": {
                                "class": "span8"
                            }
                        },
                        {
                            "items": [
                                {
                                    "items": [
                                        {
                                            "html": "",
                                            "attributes": {
                                                "class": "form-horizontal"
                                            }
                                        }
                                    ],
                                    "attributes": {
                                        "class": "span4"
                                    }
                                }
                            ],
                            "attributes": {
                                "class": "row"
                            }
                        },
                        {
                            "items": [
                                {
                                    "items": [
                                        {
                                            "tag": "input",
                                            "attributes": {
                                                "type": "button",
                                                "value": Monet.I18n.getResourcesByKey("default.button.save"),
                                                "name": "btn_save_assign",
                                                "id": "btn_save_assign",
                                                "class": "btn"
                                            }
                                        },
                                        {
                                            "tag": "input",
                                            "attributes": {
                                                "type": "button",
                                                "value": Monet.I18n.getResourcesByKey("default.button.cancel"),
                                                "name": "btn_exit_assign",
                                                "id": "btn_exit_assign",
                                                "class": "btn"
                                            }

                                        }
                                    ],
                                    "attributes": {
                                        "class": "form_assign_taskResolution___buttons standard-form-buttons"
                                    }
                                }
                            ],
                            "attributes": {
                                "class": "row"
                            }
                        }
                    ],
                    "attributes": {
                        "id": "form_assign_taskResolution"
                    }
                }
            ]
        };

        return ( new Monet.UI.LayoutGenerator(layout) ).render();
    };

    this.addEventListenners = () => {
        try {
            const btnSave = document.querySelector("#form_assign_taskResolution #btn_save_assign");
            const btnCancel = document.querySelector("#form_assign_taskResolution #btn_exit_assign");

            btnSave.onclick = () => {
                this.assignTaskResolutionToTask();
            };

            btnCancel.onclick = () => {
                this.modalForm.closeModalWindow();
                taskRouter.enableWorkflowButtons();
            };

        } catch (e) {
            new Monet.Exception.ReturnError(this, "No add event listenner to form.")
                .console();
        }
    };

    this.validateForm = function () {
        let isValid = true;

        try {
            const field = document.querySelector("#form_assign_taskResolution #taskResolution input[type='hidden']");

            if (!field.value) {

                isValid = false;

                const errorMessages = {
                    errorMessages: [Monet.Form.Messages.mountErrorMessageObject("TaskManager.taskResolution.notSelected")]
                };

                const monetMessage = new Monet.Form.Messages.InlineMessage();
                monetMessage.setScope("#form_assign_taskResolution");
                monetMessage.setInfoType("error");
                monetMessage.setMessage(errorMessages);
                monetMessage.triggerMessage();
            }

        } catch (e) {
            new Monet.Exception.ReturnError(this, "No validate form.")
                .console();
        }

        return isValid;
    };

    const updateValueOnForm = () => {
        try {
            const taskResolutionNewValue = this.taskResolutionField.getFullValue();
            const valueContainer = document.querySelector("#Task_taskResolution .Task_taskResolution___value");
            valueContainer.innerHTML = Monet.I18n.getResourcesByKey(taskResolutionNewValue.description);
        } catch (error) {
            new Monet.Exception.ReturnError(this, "Trying update value on form.")
                .console();
        }
    };

    this.assignTaskResolutionToTask = () => {
        try {
            if (this.validateForm()) {
                this.modalForm.toggleLoadingInModalBtn('#form_assign_taskResolution .form_assign_taskResolution___buttons');
                const form = App.Forms[taskRouter.entityName].form;
                updateValueOnForm();
                form.setField('taskResolution', this.taskResolutionField);
                form.setField('taskResolutionComment', this.commentResolutionField);
                new Promise(resolve => taskRouter.update(() => resolve()))
                    .then(() => sendChangeStatusCallBack())
                    .then(() => this.modalForm.closeModalWindow());
            }
        } catch (error) {
            new Monet.Exception.ReturnError(this, "Trying assing Task Resolution to the Task.")
                .console();
        }
    };

    const init =  () => {
        const selector = "#Task #form_and_grid";
        const scopeBlock = "#Task form.MonetUIForm.Task";
        const options = { width: 415, height: 300 };
        const callbacks = {
            onAfterShowModalForm: this.addFormToModalContent,
            onAfterCloseModalForm: taskRouter.enableWorkflowButtons
        };
        this.modalForm = new Monet.Form.Modal(selector, options, callbacks, scopeBlock);
    };

    init();

    return this;

};